export default __webpack_public_path__ + "static/media/child-account.5601d4a8.svg";